export const Actions = {
  READ_COMPANY: "READ_COMPANY",
  READ_COMPANY_SUCCEEDED: "READ_COMPANY_SUCCEEDED",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  UPDATE_COMPANY_SUCCEEDED: "UPDATE_COMPANY_SUCCEEDED",
  UPLOAD_CONTRACT: "UPLOAD_CONTRACT",
  UPLOAD_CONTRACT_SUCCEEDED: "UPLOAD_CONTRACT_SUCCEEDED",
  CLEAR_OPERATION_RESULT: "COMPANY_CLEAR_OPERATION_RESULT",
  // Subscriptions
  LIST_SUBSCRIPTIONS: "COMPANY_LIST_SUBSCRIPTIONS",
  LIST_SUBSCRIPTIONS_SUCCEEDED: "COMPANY_LIST_SUBSCRIPTIONS_SUCCEEDED",
  UPSERT_SUBSCRIPTION: "COMPANY_UPSERT_SUBSCRIPTION",
  UPSERT_SUBSCRIPTION_SUCCEEDED: "COMPANY_UPSERT_SUBSCRIPTION_SUCCEEDED",
  DELETE_SUBSCRIPTION: "COMPANY_DELETE_SUBSCRIPTION",
  DELETE_SUBSCRIPTION_SUCCEEDED: "COMPANY_DELETE_SUBSCRIPTION_SUCCEEDED",
  // Pricing Schedules
  LIST_PRICING_SCHEDULES: "COMPANY_LIST_PRICING_SCHEDULES",
  LIST_PRICING_SCHEDULES_SUCCEEDED: "COMPANY_LIST_PRICING_SCHEDULES_SUCCEEDED",
  CREATE_PRICING_SCHEDULE: "COMPANY_CREATE_PRICING_SCHEDULE",
  CREATE_PRICING_SCHEDULE_SUCCEEDED: "COMPANY_CREATE_PRICING_SCHEDULE_SUCCEEDED",
  UPDATE_PRICING_SCHEDULE: "COMPANY_UPDATE_PRICING_SCHEDULE",
  UPDATE_PRICING_SCHEDULE_SUCCEEDED: "COMPANY_UPDATE_PRICING_SCHEDULE_SUCCEEDED",
  DELETE_PRICING_SCHEDULE: "COMPANY_DELETE_PRICING_SCHEDULE",
  DELETE_PRICING_SCHEDULE_SUCCEEDED: "COMPANY_DELETE_PRICING_SCHEDULE_SUCCEEDED",
};